module.exports = __webpack_public_path__ + "static/media/recipt-blue.436e5c45.svg";